import React, { useEffect, useState } from 'react';

import TabAgreementPlan from './TabsFundingsPlans/TabAgreementPlan';
import TabStratProjectsPlan from './TabsFundingsPlans/TabStratProjectsPlan';
import TabCostAgrsPlans from './TabsFundingsPlans/TabCostAgrsPlans';
import TabCostKvrPlans from './TabsFundingsPlans/TabCostKvrPlans';
import { Tab, Tabs } from '../../components/Tabs';
import api from '../../api';
import { fetchPlansDictionary } from '../../helpers/plansHelper';
import BackBtn from '../../components/UI/BackBtn';

const tabs = [
  { label: 'agreement', tabName: 'План по соглашениям', content: TabAgreementPlan },
  { label: 'stratProjects', tabName: 'План по стратегическим проектам / политикам развития', content: TabStratProjectsPlan },
  { label: 'costAgrs', tabName: 'Планы по статьям затрат соглашения', content: TabCostAgrsPlans },
  { label: 'costKvr', tabName: 'Смета по статьям затрат КВР', content: TabCostKvrPlans },
];

export default function AdminFundingsPlans() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [plansDictionary, setPlansDictionary] = useState(null);

  useEffect(async () => {
    const result = await fetchPlansDictionary();
    setPlansDictionary(result);
    setIsLoaded(true);
  }, []);

  return (
    <section className="page admin-fundings-plans-page">
      <div className="container">
        <BackBtn />
        <div style={{ marginTop: 20 }}>
          <Tabs>
            {tabs
              .filter((tab) => !tab.hide || !tab.hide(userCtx.perms))
              .map((tab, i) => (
                <Tab key={i} label={tab.label} tabName={tab.tabName}>
                  <tab.content plansDictionary={plansDictionary} />
                </Tab>
              ))}
          </Tabs>
        </div>
      </div>
    </section>
  );
}
